import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import CartHelper from '../CartHelper';
import { toCartModel } from '../../../utils/ecommerce/cart.js';

const _CartHelper = new CartHelper();

class ProdQtyForm extends Component {
	constructor(props) {
		super(props);
		this.sku = this.props.sku;
		this.cartId = _CartHelper.getCartId();
		this.prodItem = {
			title: '',
			currencySymbol: '',
			price: '',
			qty: 0,
			activated: false,
		};
		this.isCarCallOn = false;
		this.prodQty = 0;
	}

	componentDidUpdate() {
		if (this.isCarCallOn) {
			this.isCarCallOn = false;
		}
	}

	getSimplifiedCartModel() {
		let currCart = Object.assign({}, this.props.cart);
		let requestModel = toCartModel(currCart);
		return requestModel;
	}

	handleQtyUpdate(operation) {
		if (this.isCarCallOn || (operation == 'deduct' && this.prodItem.qty == 1)) {
			return;
		}
		this.isCarCallOn = true;
		let { initCardData } = this.props;
		const metadata = this.props.initCardData?.metadata;
		let requestModel = this.getSimplifiedCartModel();
		requestModel.lineItems.forEach((item) => {
			if (parseInt(item.materialNumber) == parseInt(this.sku)) {
				let qty = item.quantity;
				item.quantity = operation == 'deduct' ? qty - 1 : qty + 1;
			}
		});
		let { bundleUpdates } = this.props;
		let previousAmount = !Array.isArray(bundleUpdates) ? bundleUpdates.total : 0;
		let qty = this.prodItem.qty;
		let amountChng = operation == 'deduct' ? previousAmount - this.prodItem.price : previousAmount + this.prodItem.price;
		let operationSymbol = amountChng < 0 ? '-' : '+';

		let currentUpdate = {
			skuUpdated: this.sku,
			total: amountChng,
			qtyUpdated: Object.assign({}, bundleUpdates.qtyUpdated),
			operationSymbol,
			formattedLocale: metadata?.formattedLocale,
			currency: metadata?.currency,
		};
		currentUpdate.qtyUpdated[this.sku] = operation == 'deduct' ? qty - 1 : qty + 1;
		if (operation == 'deduct') {
			try {
				window.esriShoppingCart.removeItemsFromCart(1);
			} catch (e) {
				console.warn('[Warning: global esriShoppingCart issue:] ', e);
			}
		} else {
			try {
				window.esriShoppingCart.addItemsToCart(1);
			} catch (e) {
				console.warn('[Warning: global esriShoppingCart issue:] ', e);
			}
		}

		this.props.flyoutFormsUpdate(currentUpdate);

		this.props.addToExistingCart(initCardData.istApiUrl, requestModel, this.cartId, this.props.addedBundle);
	}

	handleQtyChange(e) {
		let _target = e.target;
		let value = _target.value;
		if (this.isCarCallOn || value < 1) {
			return;
		}
		this.isCarCallOn = true;
		let { initCardData } = this.props;
		const metadata = this.props.initCardData?.metadata;
		let requestModel = this.getSimplifiedCartModel();
		requestModel.lineItems.forEach((item) => {
			if (parseInt(item.materialNumber) == parseInt(this.sku)) {
				item.quantity = parseInt(value);
			}
		});

		let { bundleUpdates } = this.props;
		let previousAmount = !Array.isArray(bundleUpdates) ? bundleUpdates.total : 0;
		let changeQty = parseInt(value);
		let operationSymbol = changeQty > this.prodItem.qty ? '+' : '-';
		let delta = operationSymbol == '+' ? changeQty - this.prodItem.qty : this.prodItem.qty - changeQty;
		if (operationSymbol == '-') {
			try {
				window.esriShoppingCart.removeItemsFromCart(delta);
			} catch (e) {
				console.warn('[Warning: global esriShoppingCart issue:] ', e);
			}
		} else {
			try {
				window.esriShoppingCart.addItemsToCart(delta);
			} catch (e) {
				console.warn('[Warning: global esriShoppingCart issue:] ', e);
			}
		}
		let priceChange = delta * this.prodItem.price;
		let amountChng = operationSymbol == '+' ? previousAmount + priceChange : previousAmount - priceChange;

		let currentUpdate = {
			skuUpdated: this.sku,
			total: amountChng,
			qtyUpdated: Object.assign({}, bundleUpdates.qtyUpdated),
			operationSymbol,
			formattedLocale: metadata?.formattedLocale,
			currency: metadata?.currency,
		};
		(currentUpdate.qtyUpdated[this.sku] = parseInt(value)), this.props.flyoutFormsUpdate(currentUpdate);

		this.props.addToExistingCart(initCardData.istApiUrl, requestModel, this.cartId, this.props.addedBundle);
	}

	render() {
		const { addedBundle, cart } = this.props;
		if (Array.isArray(addedBundle) || Array.isArray(cart)) {
			return null;
		}

		if (!this.prodItem.activated) {
			// prevent the saame opterations to repeat
			const { config, prodConfigArr } = addedBundle;
			// there may be items in the car that are not part of active bundle
			let dialogProdInfo = prodConfigArr.filter((prod) => prod.indexOf(this.sku) > 1);
			if (!dialogProdInfo.length) {
				return null;
			}

			dialogProdInfo = JSON.parse(dialogProdInfo[0]);
			let currProdConfig = config.data.filter((prod) => parseInt(prod.SKU) == parseInt(this.sku))[0];
			let prodCartInfo = cart.lineItems.filter((prod) => parseInt(prod.materialNumber) == parseInt(this.sku))[0];
			this.prodItem.title = currProdConfig.productTitle;
			this.prodItem.currencySymbol = cart.metadata.currency.currencySymbol;
			this.prodItem.price = prodCartInfo.price;
			this.prodItem.qty = currProdConfig.qty;

			if (!Array.isArray(this.props.bundleUpdates)) {
				const { bundleUpdates } = this.props;
				if ('qtyUpdated' in bundleUpdates && bundleUpdates.qtyUpdated[this.sku]) {
					this.prodItem.qty = bundleUpdates.qtyUpdated[this.sku];
				}
			}
			this.prodItem.activated = true;
		}
		return (
			<div className="quantity-picker-container">
				<div className="font-size--2">{`${this.prodItem.title} ${this.prodItem.currencySymbol}${this.prodItem.price}`}</div>

				<div className="quantity-picker">
					<button
						className="quantity-picker__minus"
						onClick={() => {
							this.handleQtyUpdate('deduct');
						}}
						aria-label={Granite.I18n.get('Decrease quantity')}
						data-event="track-component"
						data-component-name="minusClick"
						data-component-link="minusClick"
						data-component-link-placement="1"
						data-component-link-type="button">
						<span data-click="handleQtyMinus">−</span>
					</button>
					<input className="quantity-picker__qty" value={this.prodItem.qty} type="number" aria-label={Granite.I18n.get('Quantity')} />
					<button
						className="quantity-picker__plus"
						onClick={() => {
							this.handleQtyUpdate('addition');
						}}
						aria-label={Granite.I18n.get('Increase quantity')}
						data-event="track-component"
						data-component-name="plusClick"
						data-component-link="plusClick"
						data-component-link-placement="1"
						data-component-link-type="button">
						<span>+</span>
					</button>
				</div>
			</div>
		);
	}
}

function mapStateToProps({ cartState, initCardData, cart, addedBundle, bundleUpdates }) {
	return {
		cartState,
		initCardData,
		cart,
		addedBundle,
		bundleUpdates,
	};
}

export default connect(mapStateToProps, actions)(ProdQtyForm);
